import React from 'react'
import './footer.css'

import MailIcon from '@material-ui/icons/Mail';
import PhoneIcon from '@material-ui/icons/Phone';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import hnb from '../assests/image 1.png'

function footer() {
  return (
    <div className='footer'>
        <div className="footercontainer">
            <div className="foot1cont">
                <h2 >H&B</h2>
                <h4 className='logoname'>Group of Company</h4>
                <div className="mailcon"><MailIcon /><p className="subcon1">info@hnbinfo.com</p></div>
                <div className="phonecon"><PhoneIcon /><p className="subcon2">+91 9427664076<br/>+91 9737040893</p></div>
            </div>


            <div className="foot2cont">
                <div className="titlecon">POPULAR COURSES</div>
                <div className="courcecon">
                    <li>IT Solution</li>
                    <li>IT Training</li>   
                    <li>Software</li>    
                    <li>Database</li>   
                    <li>Hardware</li>   
                </div>
            </div>


            <div className="foot3cont">
                <div className="titlecon2">GET IN TOUCH</div>
                <div className="locacon"><LocationOnIcon /><p className="address">35, 2nd floor, Vinay arcade,Nr. Kamal Choice, Opp. Maninagar Rly. Station,Ahmedabad, Gujarat</p>
                </div>
            </div>


            <div className="foot4cont">
                <div className="titlecon3">MAP</div>
                <img src={hnb} alt="h&b" />
            </div>

            
        </div>
        <p className="footparam">© All right reserved 2022   |  website design & website Development By H&B Computer Education</p>
        </div>
  )
}

export default footer